export default __webpack_public_path__ + "static/media/logo-dark-mode.270e523e.svg";